import React, { useState } from "react";
import { jobBrokerService } from "../../../../Core/Api/services";
import JobsTable from "../../../../Components/Table/JobsTable/jobs-table";
import { DbJobInfos } from "../../../../Core/Api/Types/db-job-infos";

function SettingsJobs() {
    const [rows, setRows] = useState<DbJobInfos[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    React.useEffect(() => {
        setIsLoading(true);
        jobBrokerService.ListJobsWithPage(1, 500).then(function (response) {
            if (response.jobs !== null) {
                setRows(response.jobs);
            }
            setIsLoading(false);
        });
    }, []);

    return <JobsTable isLoading={isLoading} jobs={rows} />;
}

export default SettingsJobs;
